import styles from "./news-feed.module.css";

import { Flex, Spin, Button } from "antd";

import ChevronRightIcon from "@/icons/ChevronRightIcon";
import SettingsIcon from "@/icons/SettingsIcon";
import DotCircleEmpty from "@/icons/DotCircleEmpty";

import CustomLink from "@/components/ui/CustomLink";
import NotificationCard from "@/components/cards/NotificationCard";

import { readNotices, unreadNotices } from "@/api/notices";

import routes from "@/routes";

const NewsFeed = ({ notices, pending, reloadData }) => {
  const handleReadNotice = async (uuid) => {
    try {
      await readNotices([uuid]);
      reloadData();
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleUnreadNotice = async (uuid) => {
    try {
      await unreadNotices([uuid]);
      reloadData();
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleReadAllNotices = async () => {
    try {
      await readNotices();
      reloadData();
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Flex vertical className={styles.wrapper}>
      <Flex align="center" justify="space-between" className={styles.header}>
        <CustomLink
          to={routes.notices("inbox")}
          color="#0066A6"
          className={styles.headerLink}
        >
          <Flex gap={4} align="center">
            Уведомления
            <ChevronRightIcon style={{ fontSize: 14 }} />
          </Flex>
        </CustomLink>

        <CustomLink
          to={routes.notices("settings")}
          color="#BBBBBB"
          styles={{ fontSize: 20, lineHeight: 1 }}
        >
          <SettingsIcon />
        </CustomLink>
      </Flex>

      <Spin
        spinning={pending}
        wrapperClassName={`${styles.content} notices-spin`}
      >
        {!!notices?.length ? (
          <Flex vertical gap={5} className={styles.notices}>
            {notices.map((noticeGroup) =>
              noticeGroup.events.map((notice) => (
                <NotificationCard
                  key={notice.uuid}
                  data={{
                    ...notice,
                    object: noticeGroup.object,
                    object_type: noticeGroup.object_type,
                    unit: noticeGroup.unit,
                  }}
                  size="small"
                  className={styles.notice}
                  onClose={() => handleReadNotice(notice.uuid)}
                  onUnread={() => handleUnreadNotice(notice.uuid)}
                />
              ))
            )}
          </Flex>
        ) : (
          <div className={styles.empty}> Нет входящих уведомлений</div>
        )}
      </Spin>

      <Flex align="center" justify="space-between" className={styles.footer}>
        <Button
          block
          icon={<DotCircleEmpty />}
          loading={pending}
          onClick={() => {
            handleReadAllNotices();
          }}
        >
          Отметить все прочитанными
        </Button>
      </Flex>
    </Flex>
  );
};

export default NewsFeed;
